import { render, staticRenderFns } from "./icon-configurator-energy-compatibility-1.svg?vue&type=template&id=f4b7b546&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports